module.exports = {"0":{"title":["Tesla x","Iron Man"],"type":"Product design","year":"2018","img":"/Tesla/Tesla_new.mp4"},"1":{"title":["OnePlus","Crackables"],"type":"UX Design","year":"2018","img":"/Crackables/Crackables.mp4"},"2":{"title":["Travel","Service Visa"],"type":"Interface design","year":"2018","img":"/Travel/Travel.mp4"},"3":{"title":["Previous","Portfolio"],"type":"Interface design","year":"2018","img":"/Portfolio/Portfolio.mp4"},"4":{"title":["Various","Experiments"],"type":"Motion design","year":"2018","img":"/Experiments/Experiments.mp4"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/js/works.json
// module id = cffD
// module chunks = 0